// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2EnrollmentModel {
    static getAttributeTypeMap() {
        return EnrollmentV2EnrollmentModel.attributeTypeMap;
    }
}
EnrollmentV2EnrollmentModel.discriminator = undefined;
EnrollmentV2EnrollmentModel.attributeTypeMap = [
    {
        "name": "maxBenefitAmount",
        "baseName": "maxBenefitAmount",
        "type": "number"
    },
    {
        "name": "untrackedBenefit",
        "baseName": "untrackedBenefit",
        "type": "boolean"
    },
    {
        "name": "householdSize",
        "baseName": "householdSize",
        "type": "number"
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date"
    },
    {
        "name": "claimEligibilityDate",
        "baseName": "claimEligibilityDate",
        "type": "Date"
    },
    {
        "name": "paymentType",
        "baseName": "paymentType",
        "type": "number"
    },
    {
        "name": "isOptedIn",
        "baseName": "isOptedIn",
        "type": "boolean"
    },
    {
        "name": "benefitPeriodId",
        "baseName": "benefitPeriodId",
        "type": "number"
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "EnrollmentV2EligibilityModel"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "updateCaseIds",
        "baseName": "updateCaseIds",
        "type": "Array<number>"
    },
    {
        "name": "caseId",
        "baseName": "caseId",
        "type": "number"
    },
    {
        "name": "memberNumbers",
        "baseName": "memberNumbers",
        "type": "Array<EnrollmentV2MemberNumberModel>"
    },
    {
        "name": "linkedEntities",
        "baseName": "linkedEntities",
        "type": "EnrollmentCaseRelationshipsModel"
    },
    {
        "name": "caseSourceId",
        "baseName": "caseSourceId",
        "type": "number"
    },
    {
        "name": "isOpen",
        "baseName": "isOpen",
        "type": "boolean"
    },
    {
        "name": "createDate",
        "baseName": "createDate",
        "type": "Date"
    },
    {
        "name": "caseInitiatorId",
        "baseName": "caseInitiatorId",
        "type": "number"
    },
    {
        "name": "conditionTypeCodeList",
        "baseName": "conditionTypeCodeList",
        "type": "Array<string>"
    },
    {
        "name": "isQueued",
        "baseName": "isQueued",
        "type": "boolean"
    }
];
//# sourceMappingURL=enrollmentV2EnrollmentModel.js.map